import React from "react";
import PropTypes from "prop-types";

// components
import Grid2 from "core/Grid2";
import {
    generateGridItemContent,
    useSubmissionGridItems
} from "./submissionGridItems";

const PendingGroupGrid = ({ data }) => {
    const { numberOfColumns, gridSpacingSize } = useSubmissionGridItems();
    return (
        <Grid2
            numberOfColumns={numberOfColumns}
            gridSpacingSize={gridSpacingSize}
            gridItemContent={generateGridItemContent({
                gridItemData: data,
                testId: "pending-file-image"
            })}
        />
    );
};

PendingGroupGrid.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default PendingGroupGrid;
